module.exports = __webpack_public_path__ + "img/restore-white.8d531890.svg";